<ng-container [formGroup]="formGroup">
  <ng-container formArrayName="formArray">
    <ng-container *ngIf="fieldsConfig?.unique === true" formGroupName="0">
      <div class="row">
        <mat-form-field class="third-width">
          <mat-label>Compte d'instrument financier</mat-label>
          <input matInput formControlName="providerAccount" [placeholder]="fieldsConfig?.columns?.provider?.account?.defaultValue || ''">
        </mat-form-field>
        <mat-form-field class="two-thirds-width">
          <mat-label>Libellé du compte d'instrument financier</mat-label>
          <input matInput formControlName="providerAccountLabel" [placeholder]="fieldsConfig?.columns?.provider?.label?.defaultValue || ''">
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="third-width">
          <mat-label>Compte de transfert interne</mat-label>
          <input matInput formControlName="internalTransferAccount" [placeholder]="fieldsConfig?.columns?.internalTransfer?.account?.defaultValue || ''">
        </mat-form-field>
        <mat-form-field class="two-thirds-width">
          <mat-label>Libellé de compte de transfert interne</mat-label>
          <input matInput formControlName="internalTransferAccountLabel" [placeholder]="fieldsConfig?.columns?.internalTransfer?.label?.defaultValue || ''">
        </mat-form-field>
      </div>
      <ng-container *ngIf="this.fieldsConfig?.bankSupplierVisibleFor?.includes(null)">
        <div class="row">Compte utilisé pour les fonds bloqués par {{toolLabel}} :</div>
        <div class="row">
          <mat-form-field class="third-width">
            <mat-label>Racine fournisseur</mat-label>
            <input matInput formControlName="bankSupplierAccount" [placeholder]="fieldsConfig?.columns?.bankSupplier?.account?.defaultValue || ''">
          </mat-form-field>
          <mat-form-field class="two-thirds-width">
            <span matTextPrefix class="greyed-prefix">{{formArray.at(0).get('bankSupplierAccount')?.value || ''}}&nbsp;</span>
            <mat-label>Auxiliaire fournisseur {{toolLabel}}</mat-label>
            <input matInput formControlName="bankSupplierAuxiliaryAccount" [placeholder]="fieldsConfig?.columns?.bankSupplier?.auxiliaryAccount?.defaultValue || ''">
          </mat-form-field>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="fieldsConfig?.unique === false">
      <div class="header-row">
        <div class="header name">{{headerAccountLabel || 'Nom'}}</div>
        <div class="header export">Export</div>
        <div class="header journal-code" *ngIf="isJournalVisible === true">Journal</div>
        <div class="header" [ngClass]="{'account': isJournalVisible !== false, 'account-without-journal-code': isJournalVisible === false}">Comptes</div>
      </div>
      <ng-container *ngFor="let account of formArray.controls; index as i" [formGroupName]="i">
        <div class="row flex-center">
          <ng-container *ngIf="i === formArray.controls.length - 1">
            <div class="name default"
              matTooltipPosition="above"
              [matTooltip]="defaultTooltipLabel || 'La méthode suivante sera utilisée par défaut si aucune autre méthode ne correspond.'"
            >Défaut :</div>
          </ng-container>
          <ng-container *ngIf="i !== formArray.controls.length - 1">
            <mat-form-field class="name">
              <input matInput
                      (keydown.enter)="$event.preventDefault()"
                      (focus)="updateFilteredOptionsOnFocus(i)"
                      formControlName="name"
                      [matAutocomplete]="auto"
                      >
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option">{{option}}</mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </ng-container>
          <mat-slide-toggle formControlName="export" class="export"></mat-slide-toggle>
          <mat-form-field
            *ngIf="isJournalVisible === true"
            class="journal-code"
          >
            <input matInput
                    (keydown.enter)="$event.preventDefault()"
                    formControlName="journalCode"
                    autocomplete="off">
          </mat-form-field>
          <div class="column" [ngClass]="{'account': isJournalVisible !== false, 'account-without-journal-code': isJournalVisible === false}">
            <mat-form-field class="provider">
              <mat-label>{{inputProviderAccountLabel || 'Compte d\'instrument financier'}}</mat-label>
              <input matInput
                      (keydown.enter)="$event.preventDefault()"
                      formControlName="providerAccount"
                      autocomplete="off">
            </mat-form-field>
            <mat-form-field class="internal-transfer" *ngIf="this.fieldsConfig?.internalTransferVisibleFor?.includes(account.get('name')?.value ?? '')">
              <mat-label>Compte de transfert interne</mat-label>
              <input matInput
                      (keydown.enter)="$event.preventDefault()"
                      formControlName="internalTransferAccount"
                      autocomplete="off">
            </mat-form-field>
            <ng-container *ngIf="this.fieldsConfig?.bankSupplierVisibleFor?.includes(account.get('name')?.value ?? '')">
              <mat-form-field class="bank-supplier">
                <mat-label>Racine fournisseur</mat-label>
                <input matInput formControlName="bankSupplierAccount" [placeholder]="fieldsConfig?.columns?.bankSupplier?.account?.defaultValue || ''">
              </mat-form-field>
              <mat-form-field class="bank-supplier-auxiliary">
                <span matTextPrefix class="greyed-prefix">{{account.get('bankSupplierAccount')?.value || ''}}&nbsp;</span>
                <mat-label>Auxiliaire fournisseur {{toolLabel}}</mat-label>
                <input matInput formControlName="bankSupplierAuxiliaryAccount" [placeholder]="fieldsConfig?.columns?.bankSupplier?.auxiliaryAccount?.defaultValue || ''">
              </mat-form-field>
            </ng-container>
          </div>
          <button mat-button (click)="deletePaymentMethod(i)" [disabled]="fieldsConfig?.canDelete === false || i === formArray.controls.length - 1">
            <mat-icon>delete_forever</mat-icon>
          </button>
        </div>
      </ng-container>
      <button *ngIf="useSuggestedAccountToggle !== true" mat-stroked-button (click)="addPaymentMethod()" [disabled]="fieldsConfig?.canAdd === false"><mat-icon>add</mat-icon>&nbsp;{{ addLabel || 'Ajouter une méthode de paiement' }}</button>
    </ng-container>
  </ng-container>
</ng-container>